module.exports = __webpack_public_path__ + "static/img/14000265.b0b36f08.png";